import { ReactElement } from "react";
import { SituatieSoort } from "../producten-overzicht/infra/producten-overzicht-types";
import { AdviesBoxColumn, createSpanWithId } from "adviesbox-shared";
import { getAanvragersNaam } from "../shared/components/aanvrager/aanvrager-helper";
import { decimalFormat } from "../shared/utils/decimal-format";
import { cellBedragFormat, cellFormatter } from "../shared/utils/currency";

export const bepaalKredietenKolommen = (situatie: SituatieSoort): AdviesBoxColumn[] => [
  {
    Header: "Krediet",
    Cell: (c): ReactElement =>
      createSpanWithId(
        c.index,
        0,
        situatie === "huidig" ? "Bestaand" : c.original.product.doorlopend ? "Doorlopend" : "Nieuw"
      )
  },
  {
    Header: "Partij",
    Cell: (c): ReactElement =>
      createSpanWithId(c.index, 1, c.original.product.partijNaam, c.original.product.partijNaam)
  },
  {
    Header: "Soort krediet",
    Cell: (c): ReactElement =>
      createSpanWithId(c.index, 2, c.original.product.productNaam, c.original.product.productNaam)
  },
  {
    Header: "Geldnemer(s)",
    Cell: (c): ReactElement =>
      createSpanWithId(
        c.index,
        3,
        getAanvragersNaam(c.original.geldnemers.geldnemers),
        getAanvragersNaam(c.original.geldnemers.geldnemers)
      )
  },
  {
    Header: "Einddatum",
    Cell: "DateInput",
    accessor: "product.einddatum",
    config: { readonly: true }
  },
  {
    Header: "Box 1",
    Cell: (c): ReactElement => {
      return createSpanWithId(
        c.index,
        5,
        cellBedragFormat(c.original.fiscaleGegevens.deelBox1Bedrag, 0, 0, true),
        cellFormatter(c.original.fiscaleGegevens.deelBox1Bedrag, 0, true)
      );
    }
  },
  {
    Header: "Box 3",
    Cell: (c): ReactElement => {
      return createSpanWithId(
        c.index,
        6,
        cellBedragFormat(c.original.fiscaleGegevens.deelBox3Bedrag, 0, 0, true),
        cellFormatter(c.original.fiscaleGegevens.deelBox3Bedrag, 0, true)
      );
    }
  },
  {
    Header: "Rente",
    Cell: (c): ReactElement => {
      const title = `${decimalFormat(c.original.leningGegevens.rentePercentage, 2)} %`;
      return createSpanWithId(c.index, 7, title, title);
    }
  },
  {
    Header: "Maandlast",
    Cell: (c): ReactElement => {
      return createSpanWithId(
        c.index,
        8,
        cellBedragFormat(c.original.leningGegevens.maandlast.bedrag, 2, 0, true),
        cellFormatter(c.original.leningGegevens.maandlast.bedrag, 2, true)
      );
    }
  },
  {
    Cell: "DeleteButton"
  }
];
